<template>
    <div>

        <div class="row" v-if="locations.length < 3">
            <div class="col">
                <div class="presentation-upload-box">
                    <div class="p-3 p-md-8 text-center" v-if="!loading">
                        <h3 class="d-none d-md-inline">Släpp fotot här eller klicka för att välja</h3>
                        <h3 class="d-md-none">Tryck för att välja eller ta ett nytt foto</h3>
                        <div class="mt-2" style="color:#999;">Format: jpeg eller png</div>
                    </div>
                    <h3 v-if="loading">Bearbetar...</h3>
                    <input type="file" id="file_input" @change="upload" style="z-index:1;" v-if="!loading" />
                </div>
            </div>
        </div>

        <h4 v-if="locations.length">Mina foton:</h4>
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4 mb-6" :key="'l_'+index" v-for="(location, index) in locations">
                <div class="card" style="border-radius: 16px;">
                    <div class="location-popup"><img :src="'/storage/clinic-presentation/'+location.name+'.jpg'"></div>
                    <img class="card-img rounded-3 h-100" :src="'/storage/clinic-presentation/'+location.name+'.jpg'">
                    <div class="card-img-overlay p-0 d-flex justify-content-end align-items-start">
                        <button class="btn btn-sm btn-danger p-0 px-2 mt-2 me-2" title="Ta bort fotot" @click="remove(index)"><img src="/images/admin/icon-trash.svg" class="mx-0 mt-2 mb-2"></button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import axios from 'axios'

export default {

    props: {
        locations: {
            required: true
        }
    },

    data () {
        return {
            loading: false
        }
    },

    methods: {

        upload (event) {
            if (this.loading) {
                return
            }

            this.loading = true

            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)
            formData.append('type', 'location')

            axios.post(
                '/presentation/upload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.$emit('upload', response.data)
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        remove (index) {
            if(confirm("Vill du verkligen ta bort bilden?"))
            {
               this.$emit('remove', index) 
            }
            
        }
        
    }

}
</script>
